import { render, staticRenderFns } from "./orderBack.vue?vue&type=template&id=b6296c34&scoped=true&"
import script from "./orderBack.vue?vue&type=script&lang=js&"
export * from "./orderBack.vue?vue&type=script&lang=js&"
import style0 from "./orderBack.vue?vue&type=style&index=0&id=b6296c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6296c34",
  null
  
)

export default component.exports